module.exports = __webpack_public_path__ + "static/media/top3_bg.56d08943.png";